// Chart Dataset interface

export type chartType = 'line' | 'bar' | 'area' | 'scatter' | 'bubble' | 'pie' | 'doughnut' | 'polarArea' | 'radar' | undefined;
export interface ChartDataset {
  type?: chartType; // Optional type to allow mixed charts
  label: string;
  data: (number | null)[];
  borderColor: string;
  backgroundColor?: string;
  borderWidth?: number;
  borderDash?: number[];
  // Properties for min/max area band
  dataMin?: (number | null)[];
  dataMax?: (number | null)[];
  showArea?: boolean;
  areaOpacity?: number;
  // Properties for datasets with their own time axis (e.g., norm curves)
  ownLabels?: string[];
  useOwnLabels?: boolean;
  // Y-axis association for multi-axis charts
  yAxisID?: string;
}

// Chart Data interface
export interface ChartData {
  labels: string[];
  datasets: ChartDataset[];
}

// Chart Configuration interface
export interface ChartConfig {
  showGridLines?: boolean;
  yAxisUnit?: string;
  y1AxisUnit?: string;
  xAxisTickMode?: 'points' | 'intervals';
  xAxisIntervalCount?: number;
  xAxisPointTickCount?: number;
  viewBox?: { width: number; height: number };
  padding?: { top: number; right: number; bottom: number; left: number };
  chartHeight?: number;
  gridLineCount?: number;
  lineStrokeWidth?: number;
  scales?: {
    x?: {
      stacked?: boolean
    };
    y?: any; // Allow flexible Y-axis configuration
    y1?: any; // Additional Y-axis for dual-axis charts
    [key: string]: any; // Allow other axes
  }
}

// Default chart configuration
export const DEFAULT_CHART_CONFIG: ChartConfig = {
  showGridLines: true,
  yAxisUnit: '',
  viewBox: {width: 800, height: 500},
  padding: {top: 24, right: 24, bottom: 48, left: 24},
  chartHeight: 350,
  gridLineCount: 13,
  lineStrokeWidth: 2,
  scales: {
    x: {
      stacked: false
    },
    y: {
      stacked: false
    }
  }
}
